import React from "react";

import { FooterOverlay, Newsletter } from "../../components";
import { images } from "../../constants";
import "./Footer.css";

const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    {/* <Newsletter /> */}

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Me</h1>
        <p className="p__opensans_lower_case">cyppoemsandprose@gmail.com</p>
      </div>

      <div className="app__footer-links_logo">
        <p className="app__footer-headtext">Chaeyeon Park</p>
        <p className="p__opensans">
          &quot;To instill in children a wonder for the natural world&quot;
        </p>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Extra links</h1>
        <a
          href="https://linktr.ee/cssbookmaking"
          target="_blank"
          rel="noopener noreferrer"
        >
          Linktree
        </a>
      </div>
    </div>
  </div>
);

export default Footer;
